import qs from 'qs';
import client from './client';

export const listPartnerFeatures = ({ searchString }) =>
  client.get('partnerfeatures/', { params: { search: searchString } });

export const getTemplateExcelLink = () =>
  client
    .get('v1/cs/devices/registrations/template/', {
      responseType: 'blob',
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Scanner Registration Sample.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      console.error('Error downloading the file:', error);
    });

export const listDevicesExcel = ({ userRegistered } = {}) =>
  client.get('v1/cs/devices/excel/', {
    params: {
      user_registered_dev: userRegistered !== undefined ? userRegistered : true,
    },
  });

export const setFeature = ({ featureData }) =>
  client.post('v1/cs/devices/features/', featureData);

export const listDevices = ({ filters, page, registered }) => {
  const conds = {};
  // if (filters && filters.model) conds.model = filters.model;
  // if (filters && filters.searchString) conds.search = filters.searchString;
  // if (filters && filters.orderBy) conds.sort = filters.orderBy;
  Object.entries(filters).forEach(([key, value]) => {
    if (key === 'searchString') conds.search = value;
    else if (key === 'orderBy') conds.sort = value;
    else conds[key] = value;
  });
  // if (filters && filters.registeredDevices) var register = filters.registeredDevices;
  if (page) conds.page = page;
  if (registered) conds['user-registeredDevices'] = true;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get(
    // 'v1/cs/devices/' + (queryString ? `?${queryString}` : '') + (register ? register : ''),
    'v1/cs/devices/' + (queryString ? `?${queryString}` : ''),
  );
};

export const addDevices = ({ devices }) => client.post('v1/cs/devices/', devices);

export const resetRegistrations = ({ ids }) => {
  const params = { data: { ids } };
  return client.delete('v1/cs/devices/registrations/reset/', params);
};

export const deviceRegistrationInfo = (id) => client.get(`v1/cs/devices/${id}/`);

export const removeDevices = ({ ids }) => {
  const params = { data: { ids } };
  return client.delete('v1/cs/devices/remove/', params);
};

export const blockDevices = ({ block, ids }) => {
  const params = { block: block, ids };
  return client.post('/v1/cs/devices/block/', params);
};

export const listUserRegistrations = ({ filters, page }) => {
  const conds = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (key === 'searchString') conds.search = value;
    else if (key === 'orderBy') conds.sort = value;
    else conds[key] = value;
  });
  if (page) conds.page = page;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get(
    'v1/cs/user-registrations/' + (queryString ? `?${queryString}` : ''),
  );
};

export const listUsers = ({ filters, page }) => {
  const conds = {};
  if (filters && filters.instType) {
    conds.role =
      filters.instType === 'Clinic' || filters.instType === 'Lab'
        ? `Dental ${filters.instType}`
        : filters.instType;
  }
  if (filters && filters.searchString) conds.search = filters.searchString;
  if (filters && filters.orderBy) conds.sort = filters.orderBy;
  if (page) conds.page = page;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get('v1/cs/users/' + (queryString ? `?${queryString}` : ''));
};

export const listUsersExcel = () => client.get('v1/cs/users/excel/');

export const getUser = (uid) => client.get(`v1/cs/users/${uid}/`);

export const tempLogin = (uid) => client.get(`/v1/cs/users/${uid}/login/`);

export const listCases = ({ filters, page }) => {
  const conds = {};
  if (filters && filters.searchString) conds.search = filters.searchString;
  if (filters && filters.connId) conds.connId = filters.connId;
  if (filters && filters.orderBy) conds.sort = filters.orderBy;
  if (filters && filters.model) conds.model = filters.model;
  if (page) conds.page = page;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get('v1/cs/cases/' + (queryString ? `?${queryString}` : ''));
};

export const getGroup = (gid) => client.get(`v1/cs/group/${gid}/`);

export const listConns = ({ filters, page }) => {
  const conds = {};
  if (filters && filters.searchString) conds.search = filters.searchString;
  if (filters && filters.orderBy) conds.sort = filters.orderBy;
  if (page) conds.page = page;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get('v1/cs/connections/' + (queryString ? `?${queryString}` : ''));
};

export const getStats = () => client.get('v1/cs/stats/');

export const createTicket = (data) => client.post('v1/cs/devices/tickets/new/', data);

export const listTickets = ({ filters, page }) => {
  const conds = {};
  if (filters && filters.searchString) conds.search = filters.searchString;
  if (filters && filters.orderBy) conds.sort = filters.orderBy;
  if (page) conds.page = page;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get('v1/cs/devices/tickets/' + (queryString ? `?${queryString}` : ''));
};

export const listLabs = ({ filters, page }) => {
  const conds = {};
  if (filters && filters.searchString) conds.search = filters.searchString;
  if (filters && filters.orderBy) conds.sort = filters.orderBy;
  if (page) conds.page = page;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get('v1/cs/labs/' + (queryString ? `?${queryString}` : ''));
};

export const labRegister = ({ formData }) =>
  client.post('/v1/cs/labs/register/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const removeLabs = ({ ids }) => {
  const params = { ids };
  return client.post('v1/cs/labs/remove/', params);
};

export const editLab = ({ id, formData }) =>
  client.post(`v1/cs/labs/${id}/edit/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const listLab = ({ id }) => client.get(`v1/cs/labs/${id}/`);

export const getPartnerFeatures = () =>
  client.get('partnerfeatures/').then((res) => res.data);

export const updatePartnerFeatureOption = ({ id, option }) =>
  client.patch(`partnerfeatures/${id}/`, { option });

export const addPartnerFeatures = (data) =>
  client.post('partnerfeatures/bulk/', data, {
    headers: { 'Content-Type': 'application/json' },
  });

export const deletePartnerFeatures = (udis) =>
  client.post('partnerfeatures/delete/', { udis });

export const listLicenceKeys = ({ filters = {}, page = 1 } = {}) => {
  const conds = {};
  if (filters.searchString) conds.search = filters.searchString;
  if (filters.orderBy) conds.sort = filters.orderBy;
  conds.page = page;
  conds.page_size = 20;
  const qs = require('qs');
  const queryString = qs.stringify(conds, { indices: false });
  return client.get(`/v1/c4w/licencekeys/${queryString ? `?${queryString}` : ''}`);
};

export const fetchAllLicenceKeys = async () => {
  let page = 1;
  let allResults = [];
  let hasNext = true;

  while (hasNext) {
    const res = await client.get(`/v1/c4w/licencekeys/?page=${page}&page_size=100`);
    allResults = allResults.concat(res.data.results);
    hasNext = res.data.pageInfo && res.data.pageInfo.has_next;
    page += 1;
  }
  return allResults;
};

export const listVersionChecks = ({ filters, page, pageSize }) => {
  const conds = {};
  if (filters && filters.searchString) conds.search = filters.searchString;
  if (filters && filters.model) conds.model = filters.model;
  if (filters && filters.os) conds.os = filters.os;
  if (filters && filters.gpu) conds.gpu = filters.gpu;
  if (filters && filters.currentVersion) conds.currentVersion = filters.currentVersion;
  if (page) conds.page = page;
  if (pageSize) conds.page_size = pageSize;
  const queryString = qs.stringify(conds, { indices: false });
  return client.get('v1/cs/versioning/checks/' + (queryString ? `?${queryString}` : ''));
};

export const listVersionCheckModels = () => client.get('v1/cs/versioning/checks/models/');

export const listReleases = ({ filters, page, pageSize }) =>
  client.get('v1/cs/versioning/releases/', {
    params: {
      ...filters,
      page,
      pageSize,
    }
  });

export const setDefaultVersionRelease = ({ releaseId }) =>
  client.post('v1/cs/versioning/releases/set-default/', {
    release_id: releaseId
  });

export const getDefaultVersionForModel = ({ model }) =>
  client.get('v1/cs/versioning/releases/get-default/', {
    params: { model }
  });

export const setDeviceTargetVersions = ({ devices }) =>
  client.post('v1/cs/versioning/device-target/', { devices });

export const removeDeviceTargetVersions = ({ udis }) =>
  client.delete('v1/cs/versioning/device-target/', { data: { udis } });

export const listRegions = () => client.get('v1/cs/regions/');

export const getRegionDevices = ({ region, search, page, pageSize = 20 }) => {
  const params = { region, page, page_size: pageSize };
  if (search) params.search = search;
  const queryString = qs.stringify(params, { indices: false });
  return client.get(`v1/cs/regions/devices/${queryString ? `?${queryString}` : ''}`);
};

export const updateRegionCountries = ({ regionId, countryCodes }) =>
  client.post('v1/cs/regions/countries/', {
    region_id: regionId,
    country_codes: countryCodes
  });

export const getAvailableCountries = () => client.get('v1/cs/regions/available-countries/');

export const getRegionCountries = ({ region, search, page, pageSize = 20 }) => {
  const params = { page, page_size: pageSize };
  if (region && region !== 'All') params.region = region;
  if (search) params.search = search;
  const queryString = qs.stringify(params, { indices: false });
  return client.get(`v1/cs/regions/${queryString ? `?${queryString}` : ''}`);
};

export const addRegionCountry = ({ region, countryName }) =>
  client.post('v1/cs/regions/', {
    region,
    country_name: countryName
  });

export const deleteRegionCountries = ({ ids }) =>
  client.delete('v1/cs/regions/', { data: { ids } });